import { render } from "./AddPanelUsers.vue?vue&type=template&id=4c98435b&scoped=true"
import script from "./AddPanelUsers.vue?vue&type=script&lang=js"
export * from "./AddPanelUsers.vue?vue&type=script&lang=js"

import "./AddPanelUsers.vue?vue&type=style&index=0&id=4c98435b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c98435b"],['__file',"src/assets/js/components/panels/forms/AddPanelUsers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c98435b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c98435b', __exports__)) {
    api.reload('4c98435b', __exports__)
  }
  
  module.hot.accept("./AddPanelUsers.vue?vue&type=template&id=4c98435b&scoped=true", () => {
    api.rerender('4c98435b', render)
  })

}


export default __exports__